import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { addOne } from "../slices/notificationsSlice";

export default function useSwMessages() {
  const dispatch = useDispatch();
  useEffect(() => {
    const handler = (event) => {
      const msg = event?.data;
      if (!msg || msg.source !== "sw") return;
      if (msg.type === "PUSH_INCOMING") {
        const { notifId, title, body, url, createdAt } = msg.payload || {};
        dispatch(addOne({
          _id: notifId || String(Date.now()),
          name: title,
          action: body,
          time: new Date(createdAt || Date.now()).toLocaleString(),
          avatar: "/icons/icon-192.png",
          unread: true,
          url: url || "/",
        }));
      }
    };
    navigator.serviceWorker?.addEventListener?.("message", handler);
    return () => navigator.serviceWorker?.removeEventListener?.("message", handler);
  }, [dispatch]);
}
